export class Values {
    public topCategories: string[] = [];
    public featuredBrands: string[] = [];

    setPreloadedTopCategories(categories: string[]) {
        this.topCategories = categories;
    }

    setPreloadedFeaturedBrands(brands: string[]) {
        this.featuredBrands = brands;
    }

    clear() {
        this.topCategories = [];
        this.featuredBrands = [];
    }
}